export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6705.eb67114c.jpg";